<template>
	<div :class="cn('flex items-center gap-2', props.class)">
		<slot name="icon">
			<CheckCircleIcon class="size-5" />
		</slot>
		<span>{{ description }}</span>
	</div>
</template>

<script setup lang="ts">
import type { CopyToastDescriptionProps } from '.';
import { cn } from '@/utils';
import CheckCircleIcon from '~icons/mdi/check-circle';

const props = withDefaults(defineProps<CopyToastDescriptionProps>(), {
	description: 'Link copiado para a área de transferência'
});
</script>
